module.exports = __webpack_public_path__ + "static/media/building_3.b7769991.jpg";